/* eslint-disable */
var $ = require('jquery');
window.jQuery = window.$ = $; // You expose jQ as a global object
var lightCase = require('lightcase');

const lightbox = function() {


  const lb = $('a[data-rel^=lightcase]').lightcase({
		transition: 'scrollHorizontal',
		swipe: true,
    overlayOpacity: 1,
    maxWidth: 555,
		labels: {
			'sequenceInfo.of': ' z ',
		},
		video: {
			width : "1920",
			height : "1080",
		},
    ajax: {
      width : '555px',
      height : '500px',
      type : 'get',
      dataType : 'html',
      data : {}
    },
    iframe: {
      width : '555px',
      height : '500px',
      frameborder : 0
    }
	});
};

module.exports = lightbox;
/* eslint-enable */
